module.exports = function() {
  return new Worker(__webpack_public_path__ + "9ea08f1702d9b910c3ab.worker.js");
};